/**
 * Fiche Infusion — Animation fade-in au scroll
 */
(function () {
  'use strict';

  var container = document.getElementById('fiche-infusion-content');
  if (!container) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var items = container.querySelectorAll('.fiche-infusion__param, .fiche-infusion__flavor');
        items.forEach(function (item) { item.classList.add('visible'); });
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  observer.observe(container);
})();
